export default "__VITE_ASSET__DwH4vO9O__"